import { render, staticRenderFns } from "./ResetPasswordRequest.vue?vue&type=template&id=88d95792&scoped=true&"
import script from "./ResetPasswordRequest.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d95792",
  null
  
)

export default component.exports